export default {
	breakpointLarge: '@media only screen and (min-width: 700px)',
	breakpointSmall: '@media only screen and (max-width: 699px)'
  };


// WEBPACK FOOTER //
// ./src/utils/mediaQueries.js